/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Container,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';
import { toast } from 'react-toastify';
import gql from 'graphql-tag';
import _get from 'lodash/get';
import AppComponent from './AppComponent';
import Loading from './Loading';

import '../../css/AcceptInvite.css';

class AcceptInvite extends AppComponent {
  constructor() {
    super();
    this.state = {
      leave: false,
    };
  }

  acceptInvite = async () => {
    try {
      const userId = this.app.user.id;
      const inviteToken = this.props.match.params.token;
      const result = await this.props.acceptInvite({ variables: { userId, inviteToken } });
      this.app.user.facilities = this.app.user.facilities.concat(_get(result, 'data.acceptInvite.facilities'));
      toast.success('Invite accepted');
      setTimeout(() => this.setState({ leave: true }), 1000);
    } catch (err) {
      toast.error(err.message);
    }
  };

  leave = () => {
    this.setState({
      leave: true,
    });
  };

  render() {
    if (this.state.leave) {
      return (
        <Redirect to="/login" />
      );
    }

    const { inviteQuery } = this.props;
    if (inviteQuery.loading) {
      return (
        <Loading />
      );
    }

    const { inviteFromToken } = this.props.inviteQuery;

    return (
      inviteFromToken
        ?
        (
          <Container fluid id="main-container">
            <Card className="text-center AcceptInvite-card">
              <CardBody>
                <h5 className="card-title">You have been invited to join</h5>
                <p className="card-text"><strong>{inviteFromToken.facility.name}</strong></p>
                <p className="card-text">with a role of <strong>{inviteFromToken.role}</strong></p>
              </CardBody>
              <CardFooter className="text-muted">
                <Button color="success" onClick={this.acceptInvite}>Accept Invitation</Button>
                <Button color="link" onClick={this.leave}>Cancel</Button>
              </CardFooter>
            </Card>
          </Container>
        )
        :
        (
          <Container fluid id="main-container">
            <Card className="text-center AcceptInvite-card">
              <CardBody>
                <h5 className="card-title">This invite has been used or is invalid</h5>
              </CardBody>
              <CardFooter>
                <Button color="link" onClick={this.leave}>Ok</Button>
              </CardFooter>
            </Card>
          </Container>
        )
    );
  }
}

const INVITE_QUERY = gql`
  query getInviteFromToken($inviteToken: String!) {
    inviteFromToken(inviteToken: $inviteToken) {
      email
      role
      facility {
        id
        name
      }
    }
  }
`;

const ACCEPT_INVITE = gql`
  mutation acceptInvite($userId: String!, $inviteToken: String!) {
    acceptInvite(
      userId: $userId
      inviteToken: $inviteToken
    ) {
      facilities {
        id
      }
    }
  }
`;

export default compose(
  graphql(ACCEPT_INVITE, {
    name: 'acceptInvite',
  }),
  graphql(INVITE_QUERY, {
    name: 'inviteQuery',
    options: props => ({
      variables: {
        inviteToken: props.match.params.token,
      },
    }),
  }),
)(AcceptInvite);



// WEBPACK FOOTER //
// ./src/components/core/AcceptInvite.js